import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import { axios } from "lib/axios";
import {baseUrl} from "../../util/keys";

import {
    CLIENT_GET_ALL_CLIENTS
} from "../../constants/ActionTypes";
import {
    getClientsListSuccess,
    showErrorMessage,

} from "../../actions";
import {
    HTTP_TIMEOUT,
    URL_CLIENT_ALL, URL_SURVEY_QUESTION_TYPE_LIST,
} from "../../constants/Urls";
import AppUtils from "../../util/util";
import { store } from "MainApp";


/************ methods : http *******************/

const httpGetAllClients = async (data) =>

    await axios.get(baseUrl + URL_CLIENT_ALL, AppUtils.getHttpHeaders())
        .then(authUser => authUser)
        .catch(error => error);


/************ methods : http response handler *******************/

function* getAllClientsData() {
    try {
        // avoid the initial call when the auth store is not ready
        const authUser = store.getState().auth.user;
        if (!authUser || Object.keys(authUser).length === 0) {
            return;
        }

        let dataValue = yield call(httpGetAllClients, {});
        if (dataValue.message) {
            yield put(showErrorMessage(dataValue.message));
        } else {
            yield put(getClientsListSuccess(dataValue.data));
        }
    } catch (error) {
        yield put(showErrorMessage(error));
    }
}

/************ methods : export access *******************/

export function* getAllClients() {
    yield takeEvery(CLIENT_GET_ALL_CLIENTS, getAllClientsData);
}

export default function* rootSaga() {
    yield all([
        fork(getAllClients),
    ]);
}
